import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { expr } from 'mobx';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import { get } from 'lodash/fp';

// data imports
import { draggableClass } from 'logic/data/Izenda.ReportPartKPIConstants.js';

// local dependencies
import KPIPreview from './Izenda.KPIPreview';

@observer
class KPIMetricContainer extends Component {

    renderKPI = () => {
        const { props } = this;
        const sizeStyle = props.style ? props.style : {};
        return <KPIPreview {...props} style={sizeStyle} />;
    };

    render() {
        const isBeingBuild = expr(() => get('isBeingBuild', this.props.reportPart.reportPartContent));
        const style = {
            height: '100%',
            ...!this.props.isBorderConfig ? this.props.tile.properties.getBorderStyle() : {}
        }
        return (
            <div style={style}>
                {
                    isBeingBuild ?
                    this.renderKPI() :
                    <div className={`kpi-default-layout ${draggableClass}`}>
                        <span className='icomoon-looks_one'></span>
                    </div>
                }
            </div>
        );
    }
}

KPIMetricContainer.propTypes = {
    isBorderConfig: PropTypes.bool,
    reportPart: MobxPropTypes.observableObject.isRequired,
    style: PropTypes.object,
    tile: MobxPropTypes.observableObject,
};

export default KPIMetricContainer;



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartKPI/Izenda.KPIMetricContainer.jsx